/*
 *  截取几位字符串    num 截取数 
 */
exports.reserveStr = (val, num) => {
    let str = String(val);
    return str.length > num ? str.substring(0, num) + '...' : str;
};
//多久前
exports.dateLong = (val) => {
    val = val.split('-').join('/');

    let last = new Date(val);
    let date = new Date();
    let h = '';
    if (date > last) {
        var jujin = (date - last) / 1000;
        if (jujin > 172800) {
            h = val.substring(0, 19);
        } else {
            let day = Math.floor(jujin / 86400);
            h += (day > 0 ? day + '天' : '');

            let hover = Math.floor(jujin % 86400 / 3600);
            h += (hover > 0 ? hover + '小时' : '');

            let mouse = Math.floor(jujin % 86400 % 3600 / 60);
            h += (mouse > 0 ? mouse + '分钟' : '');

            h += (h == '' ? '刚刚发布' : '前');
        }
        ;
        return h
    }
};
//截取时间
exports.reserveTime = (val, num) => {
    return String(val).substring(0, num);
};

/* 
 * 保留几位小数   num 保留位数 
 */
exports.reserveNum = (val, num) => {

    return parseFloat(val).toFixed(num);
};

//字符串转数字
exports.strToNum = (val) => {
    return parseInt(val);
}

//小写转大写
exports.capitalize = (value) => {
    if (!value) return '';
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1);
};

//取绝对值
exports.Mabs = (value) => {
    if (!value) return 0;
    return Math.abs(value);
};
//全局过滤数据，固定两位小数
exports.fixTwo = (value) => {
    if (!value) return 0;
    return value.toFixed(2);
};
//去掉小数点后无效的零
exports.zero = (value) => {
    if (!value) return 0;
    return parseFloat(value);
};
//过滤控制台展示数据
exports.zeroInvalid = (value) => {
    if (!value) return '- ';
    if (parseFloat(value) == 0) return '0';

    return parseFloat(value).toLocaleString();
};

//过滤小数位数
exports.decimal = (value) => {
    if (!value) return '';
    let dec = Number(value).toFixed(5);

    return parseFloat(dec)
};

//0空null转为-
exports.noData = (value) => {
    if (!value) return '-';
};

//小于0转为-
exports.noData2 = (value) => {
    if (value < 0) return '-'
};


//数值超过三位加分隔符
exports.NumFormat = (value) => {
    if (!value) return '0.00';
    var intPart = Number(value).toFixed(0); //获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

    var floatPart = ".00"; //预定义小数部分
    var value2Array = toString(value).split(".");

    //=2表示数据有小数位
    if (value2Array.length == 2) {
        floatPart = value2Array[1].toString(); //拿到小数部分

        if (floatPart.length == 1) { //补0,实际上用不着
            return intPartFormat + "." + floatPart + '0';
        } else {
            return intPartFormat + "." + floatPart;
        }

    } else {
        return intPartFormat + floatPart;
    }
};


//异常数据   秒 转为分钟 小时 天
exports.sToMinute = (val) => {
    let h = '';
    if (val > 86400) {
        h += parseInt(val / 86400) + '天';
    }
    if ((val % 86400) > 3600) {
        h += parseInt(val % 86400 / 3600) + '小时';
    }
    h += parseInt(val % 86400 % 3600 / 60) + '分钟';
    return h;
}